import { render, staticRenderFns } from "./ExtranetHeader.vue?vue&type=template&id=54ef108d&scoped=true"
import script from "./ExtranetHeader.vue?vue&type=script&lang=ts"
export * from "./ExtranetHeader.vue?vue&type=script&lang=ts"
import style0 from "./ExtranetHeader.vue?vue&type=style&index=0&id=54ef108d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef108d",
  null
  
)

export default component.exports